import React from 'react';
import Alert from 'src/modules/shared/alert/components/alert';

const alertStyle = {
  margin: '-30px -22.5px 20px',
  borderBottomLeftRadius: 0,
  borderBottomRightRadius: 0,
  textAlign: 'center',
};

export default class ModalAlert extends React.Component {
  render() {
    return <Alert noClose={true} style={alertStyle}>
      {this.props.children}
    </Alert>;
  }
};



// WEBPACK FOOTER //
// ./src/modules/shared/modal/components/signup/modalAlert.js